// utils/canadaDepartmentConfig.js - Canada Department Configuration (Only actual feeds)

export const canadaDepartmentConfig = {

    'prime-minister': {
      departmentInfo: {
        name: "Prime Minister's Office",
        image: '/canada-pm.svg',
        officialURL: 'https://www.pm.gc.ca/',
        missionStatement: 'The Prime Minister\'s Office supports the Prime Minister in providing leadership and direction to the Government of Canada.',
        route: '/canada/prime-minister',
        urlKey: 'prime-minister'
      },
      mainFeeds: [
        {
          id: 'primeMinisterOffice',
          name: "Prime Minister's Office",
          apiParams: '&schema=canada&table=prime_minister&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'canada-revenue-agency': {
      departmentInfo: {
        name: 'Canada Revenue Agency',
        image: '/canada-cra.svg',
        officialURL: 'https://www.canada.ca/en/revenue-agency.html',
        missionStatement: 'The Canada Revenue Agency administers tax laws for the Government of Canada and for most provinces and territories.',
        route: '/canada/canada-revenue-agency',
        urlKey: 'canada-revenue-agency'
      },
      mainFeeds: [
        {
          id: 'cra',
          name: 'Canada Revenue Agency',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canada%20Revenue%20Agency',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'impact-assessment-agency': {
      departmentInfo: {
        name: 'Impact Assessment Agency of Canada',
        image: '/canada-iaac.svg',
        officialURL: 'https://www.canada.ca/en/impact-assessment-agency.html',
        missionStatement: 'The Impact Assessment Agency of Canada conducts federal impact assessments of proposed projects.',
        route: '/canada/impact-assessment-agency',
        urlKey: 'impact-assessment-agency'
      },
      mainFeeds: [
        {
          id: 'impactAssessment',
          name: 'Impact Assessment Agency of Canada',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Impact%20Assessment%20Agency%20of%20Canada',
          feedBranch: 'Executive',
          feedTopic: 'Environment',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'canadian-food-inspection-agency': {
      departmentInfo: {
        name: 'Canadian Food Inspection Agency',
        image: '/canada-cfia.svg',
        officialURL: 'https://www.canada.ca/en/food-inspection-agency.html',
        missionStatement: 'The Canadian Food Inspection Agency safeguards food, animals and plants.',
        route: '/canada/canadian-food-inspection-agency',
        urlKey: 'canadian-food-inspection-agency'
      },
      mainFeeds: [
        {
          id: 'foodInspection',
          name: 'Canadian Food Inspection Agency',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Food%20Inspection%20Agency',
          feedBranch: 'Executive',
          feedTopic: 'Health',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'atlantic-canada-opportunities-agency': {
      departmentInfo: {
        name: 'Atlantic Canada Opportunities Agency',
        image: '/canada-acoa.svg',
        officialURL: 'https://www.canada.ca/en/atlantic-canada-opportunities.html',
        missionStatement: 'ACOA works to create opportunities for economic growth in Atlantic Canada.',
        route: '/canada/atlantic-canada-opportunities-agency',
        urlKey: 'atlantic-canada-opportunities-agency'
      },
      mainFeeds: [
        {
          id: 'atlanticOpportunities',
          name: 'Atlantic Canada Opportunities Agency',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Atlantic%20Canada%20Opportunities%20Agency',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'federal-economic-development-southern-ontario': {
      departmentInfo: {
        name: 'Federal Economic Development Agency for Southern Ontario',
        image: '/canada-feddev.svg',
        officialURL: 'https://www.canada.ca/en/economic-development-southern-ontario.html',
        missionStatement: 'FedDev Ontario advances economic development of Southern Ontario.',
        route: '/canada/federal-economic-development-southern-ontario',
        urlKey: 'federal-economic-development-southern-ontario'
      },
      mainFeeds: [
        {
          id: 'feddevOntario',
          name: 'Federal Economic Development Agency for Southern Ontario',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Federal%20Economic%20Development%20Agency%20for%20Southern%20Ontario',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'canada-border-services-agency': {
      departmentInfo: {
        name: 'Canada Border Services Agency',
        image: '/canada-cbsa.svg',
        officialURL: 'https://www.cbsa-asfc.gc.ca/',
        missionStatement: 'CBSA facilitates legitimate travel and trade while providing integrated border services.',
        route: '/canada/canada-border-services-agency',
        urlKey: 'canada-border-services-agency'
      },
      mainFeeds: [
        {
          id: 'borderServices',
          name: 'Canada Border Services Agency',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canada%20Border%20Services%20Agency',
          feedBranch: 'Executive',
          feedTopic: 'Defense',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'canadian-transportation-agency': {
      departmentInfo: {
        name: 'Canadian Transportation Agency',
        image: '/canada-cta.svg',
        officialURL: 'https://www.otc-cta.gc.ca/',
        missionStatement: 'The Canadian Transportation Agency is an independent tribunal and regulator.',
        route: '/canada/canadian-transportation-agency',
        urlKey: 'canadian-transportation-agency'
      },
      mainFeeds: [
        {
          id: 'transportation',
          name: 'Canadian Transportation Agency',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Transportation%20Agency',
          feedBranch: 'Executive',
          feedTopic: 'Infrastructure',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'canadian-northern-economic-development-agency': {
      departmentInfo: {
        name: 'Canadian Northern Economic Development Agency',
        image: '/canada-cannor.svg',
        officialURL: 'https://www.cannor.gc.ca/',
        missionStatement: 'CanNor promotes economic development in Canada\'s three territories.',
        route: '/canada/canadian-northern-economic-development-agency',
        urlKey: 'canadian-northern-economic-development-agency'
      },
      mainFeeds: [
        {
          id: 'northernEconomicDevelopment',
          name: 'Canadian Northern Economic Development Agency',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Northern%20Economic%20Development%20Agency',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'financial-consumer-agency': {
      departmentInfo: {
        name: 'Financial Consumer Agency of Canada',
        image: '/canada-fcac.svg',
        officialURL: 'https://www.canada.ca/en/financial-consumer-agency.html',
        missionStatement: 'FCAC protects and educates consumers of financial services.',
        route: '/canada/financial-consumer-agency',
        urlKey: 'financial-consumer-agency'
      },
      mainFeeds: [
        {
          id: 'financialConsumer',
          name: 'Financial Consumer Agency of Canada',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Financial%20Consumer%20Agency%20of%20Canada',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'public-health-agency': {
      departmentInfo: {
        name: 'Public Health Agency of Canada',
        image: '/canada-phac.svg',
        officialURL: 'https://www.canada.ca/en/public-health.html',
        missionStatement: 'PHAC promotes and protects the health of Canadians.',
        route: '/canada/public-health-agency',
        urlKey: 'public-health-agency'
      },
      mainFeeds: [
        {
          id: 'publicHealth',
          name: 'Public Health Agency of Canada',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Public%20Health%20Agency%20of%20Canada',
          feedBranch: 'Executive',
          feedTopic: 'Health',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'canadian-space-agency': {
      departmentInfo: {
        name: 'Canadian Space Agency',
        image: '/canada-csa.svg',
        officialURL: 'https://www.asc-csa.gc.ca/',
        missionStatement: 'CSA advances knowledge of space through science.',
        route: '/canada/canadian-space-agency',
        urlKey: 'canadian-space-agency'
      },
      mainFeeds: [
        {
          id: 'spaceAgency',
          name: 'Canadian Space Agency',
          apiParams: '&skip=0&schema=canada&table=agencies&order_by=created_at&filter_column=agency_name&filter_string=Canadian%20Space%20Agency',
          feedBranch: 'Executive',
          feedTopic: 'Science & Tech',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    }
  
  };
  
  // URL to config key mapping
  const canadaUrlToConfigMapping = {
    'prime-minister': 'prime-minister',
    'canada-revenue-agency': 'canada-revenue-agency',
    'impact-assessment-agency': 'impact-assessment-agency',
    'canadian-food-inspection-agency': 'canadian-food-inspection-agency',
    'atlantic-canada-opportunities-agency': 'atlantic-canada-opportunities-agency',
    'federal-economic-development-southern-ontario': 'federal-economic-development-southern-ontario',
    'canada-border-services-agency': 'canada-border-services-agency',
    'canadian-transportation-agency': 'canadian-transportation-agency',
    'canadian-northern-economic-development-agency': 'canadian-northern-economic-development-agency',
    'financial-consumer-agency': 'financial-consumer-agency',
    'public-health-agency': 'public-health-agency',
    'canadian-space-agency': 'canadian-space-agency'
  };
  
  // Helper functions
  export const getCanadaDepartmentConfig = (departmentKey) => {
    const configKey = canadaUrlToConfigMapping[departmentKey] || departmentKey;
    const result = canadaDepartmentConfig[configKey] || null;
    // console.log(`getCanadaDepartmentConfig: ${departmentKey} -> ${configKey} -> ${result ? 'FOUND' : 'NOT FOUND'}`);
    return result;
  };
  
  export const getCanadaDepartmentMainFeeds = (departmentKey) => {
    const dept = getCanadaDepartmentConfig(departmentKey);
    const mainFeeds = dept ? dept.mainFeeds : [];
    // console.log(`getCanadaDepartmentMainFeeds: ${departmentKey} -> ${mainFeeds.length} main feeds`);
    return mainFeeds;
  };
  
  export const getCanadaDepartmentAgencies = (departmentKey) => {
    const dept = getCanadaDepartmentConfig(departmentKey);
    const agencies = dept ? dept.agencies : [];
    // console.log(`getCanadaDepartmentAgencies: ${departmentKey} -> ${agencies.length} agencies`);
    return agencies;
  };
  
  export const transformCanadaAgencyToFeed = (agency) => {
    return {
      id: agency.id,
      name: agency.name,
      displayType: 'normal',
      apiParams: agency.apiParams,
      feedBranch: 'Executive',
      feedTopic: agency.topic,
      buttonName: agency.buttonName || 'Doc'
    };
  };
  
  export default canadaDepartmentConfig;